import * as types from './collaborativeProvision.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_COLLABORATIVE_PROVISION,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_COLLABORATIVE_PROVISION,
		payload,
	}),
	get: payload => ({
		type: types.GET_COLLABORATIVE_PROVISION,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_COLLABORATIVE_PROVISION,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_COLLABORATIVE_PROVISION,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
